//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  name: 'Questionnaire',
  methods: {
    ...mapActions([
      'closeQuestionnaireDialog'
    ]),
    setBodyPosition() {
      // 防止滑动弹窗时父页面也被拉动
      const iframe = document.querySelector('#iFrame')
      if (iframe.attachEvent) { // 处理兼容行问题 - IE
        iframe.attachEvent('onload', function () {
          document.body.style.position = 'fixed'
        })
      } else {
        iframe.onload = function () {
          document.body.style.position = 'fixed'
        }
      }
    }
  },
  mounted () {
    this.setBodyPosition()
  }
}



// WEBPACK FOOTER //
// ./src/views/zhongshan/components/Questionnaire.vue